export default __webpack_public_path__ + "static/media/Ghostweave Drape (Unchained Version).6a080b74.jpg";